import { call } from 'redux-saga/effects';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import { fetchDonorSummaryReport as fetchDonorSummaryReportRoutine } from './routines';

export const fetchDonorSummaryReport = ({ payload: body }) =>
  sagaRoutineRequest(fetchDonorSummaryReportRoutine, {
    request: () => call(Api.fetchDonorSummaryReport, body)
  });
